enum ROLE {
  admin = 'admin',
  user = 'user',
}

export default ROLE;
